"use client";
import React, { useState, useRef, useEffect } from "react";
import { WeirdDots } from "../../../Icon";
import { useFetchCompanyInfo } from "src/app/lib/fetchCompanyInfo";
import Button from "../../../ui/Button";

export function formatNumber(num: number) {
  if (num < 1000) {
    return num.toString();
  }
  return num / 1000 + "k";
}

export const data = [
  { header: "20K+", subHeader: "Direct Properties" },
  { header: "20K+", subHeader: "Total Branches" },
  { header: "200K", subHeader: "Total Professional Staff" },
  { header: "20+", subHeader: "Years of Experience" },
];

const TrustedPartner = () => {
  const [currentIndex, setCurrentIndex] = useState(1);
  const { data: item } = useFetchCompanyInfo();
  const stats = item?.companyStat;

  const data = [
    {
      header: formatNumber(stats?.total_properties || 0),
      subHeader: "Direct Properties",
    },
    {
      header: formatNumber(stats?.total_branch || 0),
      subHeader: "Total Branches",
    },
    {
      header: formatNumber(stats?.total_staff || 0),
      subHeader: "Total Professional Staff",
    },
    {
      header: formatNumber(
        Number(stats?.years_in_industry.match(/\d+/)?.[0]) || 0
      ),
      subHeader: "Years of Experience",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex % 4) + 1);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="py-20 sm:pt-0 pb-20">
      <div className="wrapper flex xlg:flex-col xlg:gap-10 gap-[5%]">
        <div className="first basis-1/2">
          <h2 className="mb-4 font-semibold">
            Trusted Partner In Real <br /> Estate Success
          </h2>
          <h3 className="mb-12 h5 max-w-[600px] text-secondary-main">
            {item?.companyInfo?.name}! We are excited to deliver exceptional
            real estate services across Nigeria. With direct mandates for{" "}
            {item?.companyStat?.total_properties.toLocaleString()} properties on
            the website, we are backed by {stats?.total_branch} branches and a
            dedicated team of {stats?.total_staff} real estate professionals,
            including our staff and partners with {stats?.years_in_industry}{" "}
            {""} of experience in Real Estate. We offer a wide range of
            services, including property sales, rentals, short lets, and
            essential real estate Services nationwide.
          </h3>
          <Button href="/about" className="!px-8 primary-btn text-[14px] !py-3">
            Read More
          </Button>
        </div>

        <div className="grid w-auto h-max xlg:w-max xs:mx-auto  sm:gap-6 grid-cols-2 gap-10">
          {data.map((item, index) => (
            <Card
              key={index}
              index={index + 1}
              currentIndex={currentIndex}
              {...item}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
export default TrustedPartner;

export const CompanyName = () => {
  const { data: item } = useFetchCompanyInfo();
  return <span>{item?.companyInfo?.name}</span>;
};

interface CardProps {
  index: number;
  currentIndex: number;
  header: string;
  subHeader: string;
}

const Card: React.FC<CardProps> = ({
  index,
  currentIndex,
  header,
  subHeader,
}) => {
  const cardRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (cardRef.current && index === currentIndex) {
      const rect = cardRef.current.getBoundingClientRect();
  console.log({rect})
    }
  }, [currentIndex, index]);

  const cornerPositions: string[] = [
    "bottom-0 right-0",
    "bottom-2 transform rotate-[90deg] left-0",
    "top-0 transform rotate-[260deg] right-0",
    "top-0 transform rotate-[160deg] left-0",
  ];
  const radiusPositions: string[] = [
    "rounded-br rounded-br-[2rem]",
    "rounded-bl rounded-bl-[2rem]",
    "rounded-tr rounded-tr-[2rem]",
    "rounded-tl rounded-tl-[2rem]",
  ];
  const dotPosition: string = cornerPositions[(index - 1) % 4];
  const cornerPosition: string = radiusPositions[(index - 1) % 4];
  const isActive: boolean = index === currentIndex;

  return (
    <div
      ref={cardRef}
      className={`relative flex overflow-hidden bg-[rgba(var(--primary-color-rgb),0.1)] h-[clamp(150px,10vw,270px)] xxs:h-[120px] xxs:w-[150px] w-[clamp(180px,15vw,300px)] p-6 border rounded-lg ${cornerPosition} transition-transform duration-500 ${
        isActive ? "scale-[1.2]" : "scale-100"
      }`}
    >
      <div className="item">
        <h4 className="font-bold text-themeColor">
          {Number(header).toLocaleString()}
        </h4>
        <h5 className="text-secondary-main h6">{subHeader}</h5>
      </div>
      <WeirdDots className={`absolute ${dotPosition}`} />
    </div>
  );
};
